import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ObjectToolbarConfig } from 'src/blocks/object-toolbar';
import { ObjectToolbar } from 'src/blocks/object-toolbar';
import ControlledTabs from 'src/components/controlled-tabs';
import { PageLayout } from 'src/layouts';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import useTabs from '@/hooks/useTabs';
import { addObligationUrl } from '@/utils/urls';

const Page: FC = () => {
  const { t } = useTranslation();
  const title = t('obligations.create_new_title');
  const objectToolbarEnabled = useIsFeatureFlagEnabled('dynamic_forms');
  // Object-level toolbar (CUS-161) — flag-gated, title-only. The create surface
  // keeps its own Create / Cancel buttons on the form, so the toolbar renders the
  // title alone (no save disc, no relocated actions).
  const toolbarConfig: ObjectToolbarConfig = useMemo(
    () => ({ header: { title } }),
    [title]
  );
  const tabs = useTabs({
    parent: undefined,
    parentType: Parent_Type_Enum.Obligation,
    hrefRoot: addObligationUrl(),
    disabled: true,
  });

  return (
    <PageLayout
      title={title}
      headerOverride={
        objectToolbarEnabled ? (
          <ObjectToolbar config={toolbarConfig} />
        ) : undefined
      }
    >
      <ControlledTabs
        tabs={tabs}
        variant={'container'}
        parentType={Parent_Type_Enum.Obligation}
        disableSettings
      />
    </PageLayout>
  );
};

export default Page;
